"use strict";
var Observable_1 = require('../../Observable');
var mapTo_1 = require('../../operator/mapTo');
Observable_1.Observable.prototype.mapTo = mapTo_1.mapTo;
//# sourceMappingURL=mapTo.js.map


// WEBPACK FOOTER //
// ./techpad-upgrade/~/rxjs/add/operator/mapTo.js